"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedColorCircle = exports.SaturationWrapper = exports.SaturationPicker = exports.Label = exports.HueWrapper = exports.HueAlphaWrapper = exports.EmptyColorCircle = exports.EditableInputWrapper = exports.CustomPointer = exports.ControlersWrapper = exports.ColorPickerWrapper = exports.ColorPickerButtonWrapper = exports.ColorPickerActionsContainer = exports.ColorControls = exports.ColorCircle = exports.CircleWrapper = exports.AlphaWrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _styledIs = _interopRequireDefault(require("styled-is"));
var _templateObject;
var ColorPickerWrapper = exports.ColorPickerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__ColorPickerWrapper",
  componentId: "sc-10wosjg-0"
})(["overflow:hidden;width:215px;padding:5px 5px 10px;box-sizing:border-box;background:", ";border:none;border-radius:2px;box-shadow:0 14px 28px 0 ", ",0 0 4px 0 ", ";"], _colors["default"].white, _colors["default"].blue_015, _colors["default"].blue_006);
var ColorControls = exports.ColorControls = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__ColorControls",
  componentId: "sc-10wosjg-1"
})(["display:flex;margin-top:15px;"]);
var HueAlphaWrapper = exports.HueAlphaWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__HueAlphaWrapper",
  componentId: "sc-10wosjg-2"
})(["width:100%;margin-left:6px;"]);
function getColorFormat(color) {
  if (typeof color === 'string') {
    return "\n            background-color: ".concat(color, ";\n        ");
  }
  return "\n        background-color: rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")};\n    ");
}
var ColorCircle = exports.ColorCircle = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__ColorCircle",
  componentId: "sc-10wosjg-3"
})(["position:relative;width:24px;height:24px;box-sizing:border-box;border-radius:50%;overflow:hidden;border:solid 2px rgba(0,0,0,0.1);cursor:pointer;", " ", ""], function (props) {
  return getColorFormat(props.backgroundColor);
}, (0, _styledIs["default"])('isSquare')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        border-radius: 4px;\n        width: 44px;\n        height: 44px;\n        flex-shrink: 0;\n        cursor: default;\n    "]))));
var SelectedColorCircle = exports.SelectedColorCircle = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__SelectedColorCircle",
  componentId: "sc-10wosjg-4"
})(["display:inline-block;border-radius:50%;margin-right:4px;padding:2px;border:solid 2px ", ";"], function (props) {
  return props.isSelected ? _colors["default"].blue20 : 'transparent';
});
var EmptyColorCircle = exports.EmptyColorCircle = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__EmptyColorCircle",
  componentId: "sc-10wosjg-5"
})(["background-color:", ";width:24px;height:24px;box-sizing:border-box;border-radius:50%;overflow:hidden;::after{width:2px;content:'';height:24px;margin-left:8px;background-color:", ";display:inline-block;transform:rotate(45deg);}"], _colors["default"].white, _colors["default"].red50);
var ControlersWrapper = exports.ControlersWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__ControlersWrapper",
  componentId: "sc-10wosjg-6"
})(["padding:0 12px 0 6px;"]);
var AlphaWrapper = exports.AlphaWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__AlphaWrapper",
  componentId: "sc-10wosjg-7"
})(["position:relative;height:9px;width:100%;margin-top:10px;"]);
var HueWrapper = exports.HueWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__HueWrapper",
  componentId: "sc-10wosjg-8"
})(["position:relative;height:9px;width:100%;"]);
var SaturationWrapper = exports.SaturationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__SaturationWrapper",
  componentId: "sc-10wosjg-9"
})(["position:relative;height:112px;"]);
var SaturationPicker = exports.SaturationPicker = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__SaturationPicker",
  componentId: "sc-10wosjg-10"
})(["height:7px;width:7px;background-color:", ";border-radius:50%;border:1px solid ", ";"], _colors["default"].black, _colors["default"].white);
var CircleWrapper = exports.CircleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__CircleWrapper",
  componentId: "sc-10wosjg-11"
})(["position:relative;span{div{border:solid 1px rgba(0,0,0,0.1);box-sizing:border-box;border-radius:50%;span{div{border:none;div{box-shadow:none !important;}}}}}"]);
var ColorPickerButtonWrapper = exports.ColorPickerButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__ColorPickerButtonWrapper",
  componentId: "sc-10wosjg-12"
})(["position:absolute;position:absolute;right:-88px;top:30px;"]);
var Label = exports.Label = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__Label",
  componentId: "sc-10wosjg-13"
})(["", ";font-size:12px;font-weight:400;line-height:1.17;text-transform:uppercase;margin-bottom:10px;color:", ";"], _mixins.proximaNova, _colors["default"].neutral600);
var CustomPointer = exports.CustomPointer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__CustomPointer",
  componentId: "sc-10wosjg-14"
})(["width:13px;height:13px;box-shadow:0 3px 8px 0 rgba(36,39,43,0.3),0 1px 3px 0 rgba(0,0,0,0.2);background-color:", ";border-radius:50%;margin-top:-2.5px;margin-left:-6.5px;"], _colors["default"].white);
var EditableInputWrapper = exports.EditableInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__EditableInputWrapper",
  componentId: "sc-10wosjg-15"
})(["position:relative;width:100%;margin:15px 0;input{width:172px;border-radius:2px;background-color:#f7f7f7;", ";font-size:14px;line-height:1.43;color:", ";border:none;padding:3px 8px;}span{display:none;}"], _mixins.proximaNova, _colors["default"].neutral800);
var ColorPickerActionsContainer = exports.ColorPickerActionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBColorPickerstyles__ColorPickerActionsContainer",
  componentId: "sc-10wosjg-16"
})(["display:flex;gap:16px;margin-top:20px;"]);
//# sourceMappingURL=HBColorPicker.styles.js.map